import React from "react";
import { Modal } from "react-bootstrap";

interface IProps {
  show: boolean;
  handleClose: () => void;
  //base 64
  image: string|undefined;
  headerText: string|undefined;
}
const ModalImage: React.FC<IProps> = ({
  show,
  handleClose,
  image,
  headerText,
}) => {
  return (
    <Modal show={show} onHide={handleClose} width="300" height="300">
      <Modal.Header closeButton>
        <p className="fw-bold">{headerText}</p>
      </Modal.Header>
      <Modal.Body>
        <img src={image} className="w-100" />
      </Modal.Body>
    </Modal>
  );
};

export default ModalImage;
